import { render, staticRenderFns } from "./UsersPrivilegeCurePlans.vue?vue&type=template&id=126bfbd2&scoped=true&"
import script from "./UsersPrivilegeCurePlans.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeCurePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126bfbd2",
  null
  
)

export default component.exports